import { Avatar, Tooltip } from "@mui/material";
type Props = {};

const AppLogo = ({
  showLinkIconsOnly = false,
}: {
  showLinkIconsOnly?: boolean;
}) => {
  return (
    <Tooltip enterDelay={1000} title={process.env.REACT_APP_VERSION}>
      <Avatar
        sx={{
          width: showLinkIconsOnly ? 50 : 150,
          height: showLinkIconsOnly ? 50 : 150,
          mx: "auto",
          filter: "drop-shadow(0px 4px 20px #0000001a)",
          color: "primary.main",
          backgroundColor: "#ffffff",
          padding: "16px",
        }}
        variant="rounded"
        src="/images/logo.svg"
        alt="IMDAD"
      />
    </Tooltip>
  );
};

export default AppLogo;
